import React from 'react'
import pizzaimage1 from "../../../../../assets/images/resource/food/pizza1.jpg";
import ribaimage1 from '../../../../../assets/images/resource/food/riba1.jpg';
import kalmariimage1 from '../../../../../assets/images/resource/food/kalmari1.jpg';

function MidSide() {
    return (

        <>
            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Морски Дарове</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={kalmariimage1} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">

                

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Миди по средиземноморски</h5></div><div className="price"><span>9.90 лв</span></div></div>
                                        
                                        
                                        <div className="text desc">450 г</div>
                                       
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Калмари по гръцки</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                            </div>
                                            <div className="price"><span>14.90 лв</span></div>

                                            </div>
                                        <div className="text desc">250 г</div>
                                 
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сафрид пържен</h5></div><div className="price"><span>10.90 лв</span></div></div>

                                        <div className="text desc">250 г</div>
                                        
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Сьомга на плоча</h5></div><div className="price"><span>16.90 лв</span></div></div>
                                        <div className="text desc">с велуте сос, диви гъби и топла салата Кейл</div>
                                        <div className="text desc">400 г</div>
                            
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Октопод на плоча</h5></div><div className="price"><span>21.90 лв</span></div></div>
                                        
                                        <div className="text desc">зехтин и риган</div>
                                        <div className="text desc">200 г</div>
                                   
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Миди сен жак</h5></div><div className="price"><span>32.90 лв</span></div></div>
                                        
                                        <div className="text desc">в портокалов маслен сос</div>
                                        <div className="text desc">250 г</div>
                                   
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тигрови скариди</h5></div><div className="price"><span>16.90 лв</span></div></div>
                                        
                                        <div className="text desc">в маслен сос</div>
                                        <div className="text desc">250 г</div>
                                   
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Лангустини</h5></div><div className="price"><span>29.90 лв</span></div></div>
                                        
                                        <div className="text desc">със салата и средиземноморски сос</div>
                                        {/* <div className="text desc">250 г</div> */}
                                   
                                    </div>
                                </div>

                                

                                 
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Риба</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={ribaimage1} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">

                

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Лаврак</h5></div><div className="price"><span>7.90 лв</span></div></div>
                                        
                                        
                                        <div className="text desc">100 г</div>
                                       
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Ципура</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                            </div>
                                            <div className="price"><span>7.90 лв</span></div>

                                            </div>
                                        <div className="text desc">100 г</div>
                                 
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Фагри</h5></div>
                                        
                                        <div className="price"><span>9.90 лв</span></div></div>

                                        <div className="text desc">100 г</div>
                                        
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Див Лаврак</h5></div><div className="price"><span>10.90 лв</span></div></div>
                                        <div className="text desc">100 г</div>
                            
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Морски език</h5></div><div className="price"><span>11.90 лв</span></div></div>
                                        
                                        
                                        <div className="text desc">100 г</div>
                                   
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Пица</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={pizzaimage1} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">

                

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Маргарита</h5></div><div className="price"><span>9.90 лв</span></div></div>
                                        
                                        
                                        <div className="text desc">доматен сос, моцарела и босилек</div>
                                       
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Капричоза</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                            </div>
                                            <div className="price"><span>12.90 лв</span></div>

                                            </div>
                                        <div className="text desc">доматен сос, моцарела, прошуто кото, артишок и маслини</div>
                                 
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Дявола</h5></div><div className="price"><span>13.90 лв</span></div></div>

                                        <div className="text desc">доматен сос, моцарела, пикантен салам „Вентричина", чарвен лук</div>
                                        
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пеперони</h5></div><div className="price"><span>12.90 лв</span></div></div>
                                        <div className="text desc">доматен сос, моцарела, пеперони пиканто</div>

                            
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Куатро Формаджи</h5></div><div className="price"><span>13.90 лв</span></div></div>
                                        
                                        <div className="text desc">маскарпоне, моцарела, горгонзола и пармеджано</div>
                                        
                                   
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Прошуто крудо</h5></div><div className="price"><span>14.90 лв</span></div></div>
                                        
                                        <div className="text desc">доматен сос, моцарела, прошуто круто, рукола и пармеджано</div>
                                        
                                   
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Паста</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">

                

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Талиатели Болонезе</h5></div><div className="price"><span>12.90 лв</span></div></div>
                                         
                                       
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Талиатели с морски дарове</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                            </div>
                                            <div className="price"><span>18.90 лв</span></div>

                                            </div>
                                        
                                 
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Ризото с манатарки</h5></div><div className="price"><span>14.90 лв</span></div></div>

                                   
                                        
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            

        </>

    )
}

export default MidSide;